export default () => {
  return [
    {
      'id': 1,
      'title': 'Adobe Photoshop',
    },
    {
      'id': 2,
      'title': 'Adobe Illustrator',
    },
    {
      'id': 3,
      'title': 'Blender 3D',
    },
    {
      'id': 4,
      'title': 'Adobe InDesign',
    },
    {
      'id': 5,
      'title': 'Adobe After Effects',
    },
    {
      'id': 6,
      'title': 'Adobe Premiere Pro',
    },
    {
      'id': 7,
      'title': 'JavaScript',
    },
    {
      'id': 8,
      'title': 'PHP',
    },
    {
      'id': 9,
      'title': 'MySQL',
    },
    {
      'id': 10,
      'title': 'HTML',
    },
    {
      'id': 11,
      'title': 'CSS 3',
    },
    {
      'id': 12,
      'title': 'Sony Movie Studio Platinum',
    },
    {
      'id': 13,
      'title': 'Audacity',
    },
    {
      'id': 14,
      'title': 'Flash',
    },
    {
      'id': 15,
      'title': 'Celtx',
    },
    {
      'id': 16,
      'title': 'Canon 5D',
    },
    {
      'id': 17,
      'title': 'Canon 6D',
    },
    {
      'id': 18,
      'title': 'Panasonic DMC-GH2',
    },
    {
      'id': 19,
      'title': 'HTML 5',
    },
    {
      'id': 20,
      'title': 'Marvelous Designer',
    },
    {
      'id': 21,
      'title': 'Microsoft Access',
    },
    {
      'id': 22,
      'title': 'Classic ASP',
    },
    {
      'id': 23,
      'title': 'Swiffy',
    },
    {
      'id': 24,
      'title': 'jQuery',
    },
    {
      'id': 25,
      'title': 'Sluggo' ,
    },
    {
      'id': 26,
      'title': 'React Native' ,
    },
    {
      'id': 27,
      'title': 'Adobe XD' ,
    },
    {
      'id': 28,
      'title': 'Swift' ,
    },
    {
      'id': 29,
      'title': 'Bootstrap' ,
    },
  ];
};

